import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/catch';
import {Injectable} from '@angular/core';
import {ApiEndpoints} from '../ApiEndpoints';
import {ApiUtils} from '../ApiUtils';
import 'rxjs/add/operator/map';
import {FluxStock} from '../../model/fluxstock';
// import {SharedMethods} from "../../../util/sharedMethods";
// import {NetworkService} from "../../../util/NetworkService";

import { SharedMethods } from '../../../../util/sharedMethods-service';
import { plainToClass } from 'class-transformer';
import { Flux } from '../../model/flux';


@Injectable()
export class FluxService {

  iSconnecting: boolean = false;
  fluxCaisse: Flux[];

  constructor(public apiEndpoints: ApiEndpoints, public http: HttpClient,
              public apiUtils: ApiUtils,
              // public networkService:NetworkService,
              public sharedMethods: SharedMethods,
              ) { }

  getCaisse(patner?, nature?) {

      this.iSconnecting = true;
      return new Promise<Flux[]>(resolve => {
          this.http.get(this.apiEndpoints.URL_GET_CAISSE(patner, nature),
            {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
            .subscribe( (data: Flux[]) =>  {

              this.fluxCaisse = plainToClass(Flux, data);
              resolve(data);
              this.iSconnecting = false;

            },
            err => {
              // console.log(err);
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              this.iSconnecting = false;
            });
      });

  }

 saveFlux(flux: Flux, idcompteTransfert: number, idsourceCredit: number, idsourceVersment: number) {

      this.iSconnecting = true;
      let idcompte = null;
      let idOpCompte = null;
      let idPartenaire = null;

      let idSession = null;

      if (flux.compte !== undefined && flux.compte !== null)
      idcompte = flux.compte.id;

      if (flux.op_compte !== undefined && flux.op_compte !== null)
      idOpCompte = flux.op_compte.id;

      if (flux.partenaire !== undefined && flux.partenaire !== null)
      idPartenaire = flux.partenaire.id;

      if (flux.cashsession !== undefined && flux.cashsession !== null)
      idSession = flux.cashsession.id;

      const fl = {
        libelle: flux.libelle,
        natureFlux: flux.nature_flux,
        dateFlux: this.sharedMethods.converStringToDatetime(flux.date_flux),
        typeFlux: flux.type_flux,
        montant: flux.montant,
        compte: idcompte,
        opCompte: idOpCompte,
        partenaire: idPartenaire,
        cashstate: idSession,
      };


      if (flux.id !== 0) {

        return new Promise<FluxStock>(resolve => {
          this.http.patch(this.apiEndpoints.GET_URL_PATCH_FLUX(flux.id), fl,
            {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
            .subscribe((data: FluxStock) => {
                resolve(data);
                this.iSconnecting = false;
              },
              err => {
                this.sharedMethods.errorApiShow(err.error.code, err.error.message);
                // alert(JSON.stringify(err));
                this.iSconnecting = false;
              });
        });

      } else {

        return new Promise<FluxStock>(resolve => {
          this.http.post(this.apiEndpoints.GET_URL_POST_FLUX(idcompteTransfert, idsourceCredit, idsourceVersment), fl,
            {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
            .subscribe((data: FluxStock) => {
                resolve(data);
                this.iSconnecting = false;
              },
              err => {
                this.sharedMethods.errorApiShow(err.error.code, err.error.message);
                // alert(JSON.stringify(err));
                this.iSconnecting = false;
              });
        });

      }



  }

  deleteFlux(flux: Flux) {
      this.iSconnecting = true;
      return new Promise(resolve => {
        this.http.delete(this.apiEndpoints.GET_URL_DELETE_FLUX(flux.id),
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe(data => {
              resolve(data);
              this.iSconnecting = false;
          },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              this.iSconnecting = false;
          });
      });

  }

}
